import Link from 'next/link';
import React from 'react';
import { Page } from '@model/common/pages';
import { PlainLinkStyles } from '@styles/common';

export interface HelpLinkProps {
  path: string;
  children?: any;
}

export const HelpLink = ({ path, children }: HelpLinkProps) => {
  return (
    <Link prefetch={false} href={`${Page.HELP}/[pageId]`} as={path} passHref style={PlainLinkStyles}>
      {children}
    </Link>
  );
};
